import React, { useState } from 'react';
import RadiusCenter from './RadiusCenter';
import RadiusSelector from './RadiusSelector';

function splitRadiusFilterValue(selected) {
    if (!selected) {
        return [null, null];
    }

    const radiusSplitPosition = selected.lastIndexOf(',');

    return [
        selected.substr(0, radiusSplitPosition),
        selected.substr(radiusSplitPosition + 1),
    ];
}

const Radius = ({register, selected}) => {
    const [selectedCenter, selectedRadius] = splitRadiusFilterValue(selected);
    const [center, setCenter] = useState(selectedCenter || '');
    const [radius, setRadius] = useState(selectedRadius || '5km');

    return <>
        {/* Hidden input that contains the actual filter value */}
        <input type="hidden" ref={register} name="radius" value={center.length > 0 ? `${center},${radius}` : ''} />
        <div className="form-group filter-location">
            <RadiusCenter center={center} setCenter={setCenter} />
            {center.length > 0 && <RadiusSelector radius={radius} setRadius={setRadius} />}
        </div>
    </>;
};

export default Radius;
